import React, { useState, useEffect } from "react";
import categoriesModel from "venuescanner-js/react/components/VirtualEvents/models/categories";
import CategoryHero from "venuescanner-js/react/components/VirtualEvents/components/CategoryHero";
import EventsList from "venuescanner-js/react/components/VirtualEvents/components/EventsList";
import MoreInfo from "venuescanner-js/react/components/VirtualEvents/components/MoreInfo";
import CategorySwitcher from "venuescanner-js/react/components/VirtualEvents/components/CategorySwitcher";
import Form from "venuescanner-js/react/components/VirtualEvents/components/Form";

// import lazyload from 'venuescanner-js/vanilla/widgets/lazyload'
import isSSR from "venuescanner-js/services/isSSR";

const Events = (props) => {
  const [activeCategory, setActiveCategory] = useState(
    categoriesModel.find(({ slug }) => slug === props.match.params.category)
  );
  const [isFormOpen, setIsFormOpen] = useState(false);

  useEffect(() => {
    if (isSSR()) return;
    setActiveCategory(
      categoriesModel.find(({ slug }) => slug === props.match.params.category)
    );
    window.scrollTo(0, 0);
    // lazyload.init()
  }, [props.match.params.category]);

  useEffect(() => {
    if (isSSR()) return;
    document.querySelectorAll(".scroll-to").forEach((item) => {
      item.addEventListener("click", () => {
        const node = document.getElementById(item.dataset.scrollTo);
        const position =
          node.getBoundingClientRect().top + window.pageYOffset - 100;
        return window.scrollTo({
          top: position,
          left: 0,
          behavior: "smooth",
        });
      });
    });
  }, [activeCategory]);

  return (
    <div>
      <CategoryHero
        category={activeCategory}
        setActiveCategory={setActiveCategory}
      />
      <EventsList category={activeCategory} setIsFormOpen={setIsFormOpen} />
      <MoreInfo setIsFormOpen={setIsFormOpen} />
      <CategorySwitcher
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
      />
      {isFormOpen && <Form setIsFormOpen={setIsFormOpen} />}
    </div>
  );
};

export default Events;
